const { isBrowser } = require("./browser")

function getItem(key) {
  if (isBrowser()) {
    return localStorage.getItem(key)
  }
}

function setItem(key, data) {
  if (isBrowser()) {
    localStorage.setItem(key, data)
  }
}

function removeItem(key) {
  if (isBrowser()) {
    localStorage.removeItem(key)
  }
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
}
